import {
    ballroomOnlineChatRef,
    eventReportRef,
    feedbackRef,
    questionsRef,
    socialWallRef,
    usersRef
} from "../../config/firebaseConfig";
import {getAll} from "./firebaseHelpers";
import {ItemTypes} from "../../constants";


export async function getEventReport(){
    const report = await eventReportRef.doc('report').get().then(sn => sn.data())
    return report || await generateAndUpdateEventReport()
}

export async function generateAndUpdateEventReport() {
    const report = await generateEventReport()
    console.log(report)
    await eventReportRef.doc('report').set(report)
    return report;
}

export async function generateEventReport() {
    const users = await getAll(usersRef)
    const feedbacks = await getAll(feedbackRef)
    const socialWall = await getAll(socialWallRef)
    const onlineChat = await getAll(ballroomOnlineChatRef)
    const qaChat = await getAll(questionsRef)

    return {
        usersAmount: users.length,
        feedbacks: feedbacks.length,
        socialWallPhotos: socialWall.filter(_ => _.type === ItemTypes.PHOTO).length,
        socialWallMessages: socialWall.filter(_ => _.type === ItemTypes.MESSAGE).length,
        onlineChatMessages: onlineChat.length,
        questions: qaChat.length,
        questionsLikes: qaChat.map(q => q.likes).flat().length
    }
}